<template lang="pug">
  v-row
    v-col
      h1 Список меток
      v-data-table(
        :headers="headers"
        :items="tags"
      )
        template(v-slot:top)
          v-toolbar(flat)
            v-spacer
            create-tag-dialog(@save="getTagList")
        template(v-slot:item.tag="{ item }")
          v-chip.font-weight-bold.my-3.black--text(
            :color="item.color"
            :class="{ 'white--text': invertColor(item.color) }"
          ) {{ item.name }}
        template(v-slot:item.actions="{ item }")
          create-tag-dialog(v-if="item.name" :initial-data="{ ...item }" @save="onUpdate($event)")
          delete-dialog(
            v-model="item.showDelete"
            :request-id="item.id"
            :request="$api.tag.delete"
            @delete="onDelete"
          )
          v-btn.ml-2(@click="item.showDelete = !item.showDelete" color="red" fab x-small)
            v-icon(color="white") mdi-delete

</template>

<script>
import CreateTagDialog from '@/modules/Tags/components/CreateTagDialog.vue';
import { invertColor } from '@/utils/color-functions';

export default {
  name: 'TagList',
  components: { CreateTagDialog },
  data: () => ({
    headers: [
      { text: 'Метка', value: 'tag' },
      { text: 'Действия', value: 'actions', align: 'end' },
    ],
    tags: [],
  }),
  mounted() {
    this.getTagList();
  },
  methods: {
    getTagList() {
      this.$rHandler(
        this.$api.tag.index(),
        (r) => {
          this.tags = r.data.data;
          this.tags.forEach((t) => {
            this.$set(t, 'showDelete', false);
          });
        },
      );
    },
    onUpdate(tag) {
      const tagIndex = this.tags.findIndex((t) => t.id === tag.id);
      this.tags[tagIndex].name = tag.name;
      this.tags[tagIndex].color = tag.color;
    },
    onDelete(id) {
      this.tags = this.tags.filter((t) => t.id !== id);
    },
    invertColor,
  },
};
</script>

<style lang="scss" scoped>

</style>
